<script setup lang="ts">
/** Section « Objectif du client » (capture DT, section 2). */
import { FlagIcon } from '@heroicons/vue/24/outline'

defineProps<{ objectiveError?: string }>()
const objective = defineModel<string>('objective', { required: true })
</script>

<template>
  <section class="card border border-base-300 bg-base-100 shadow-sm" aria-labelledby="accomp-objective-title">
    <div class="card-body gap-3 p-4 md:p-6">
      <h2 id="accomp-objective-title" class="card-title flex items-center gap-2 text-lg font-semibold">
        <FlagIcon class="h-5 w-5 text-primary" aria-hidden="true" />
        Objectif du client <span class="text-error" aria-hidden="true">*</span>
      </h2>
      <p id="accomp-objective-help" class="text-sm text-base-content/70">
        Décrivez en quelques lignes : quel est le besoin ? pourquoi ce projet ? quel problème
        résoudre ? quels objectifs métier ?
      </p>
      <textarea
        id="accomp-objective"
        v-model="objective"
        rows="5"
        class="textarea textarea-bordered w-full text-base"
        :class="{ 'textarea-error': objectiveError }"
        placeholder="Ex. Le client veut fiabiliser son accès internet avant l'ouverture de son 2ᵉ site…"
        aria-describedby="accomp-objective-help"
      ></textarea>
      <p v-if="objectiveError" class="text-sm text-error">{{ objectiveError }}</p>
    </div>
  </section>
</template>
